export default function IconCheckbox({ className }: { className?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className={className}>
      <path d="M4.7998 12L10.7998 17.4L19.1998 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/>
    </svg>
  );
}
